import React, { useEffect, useState } from 'react'
import { ButtonAddHLPure, ButtonHLPure, DialogContractor, FilterHLPure, GridSelectionHLPure, SearchBarHLPure } from '../../pures'
import { HeaderColumnOne, CellColumnOne, HeaderSemaforo, CellSemaforo } from '../../pures/gridSemaforo/gridSemaforo-cells';
import { Grid } from '@material-ui/core';
import { useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const RepseStatusCompanyView = (props) => {
    const {
        selectedYear,
        selectedCompany,
        getColorByCompanyStatus,
        contractors,
        getColorByContractorStatus,
        yearFilterOptions,
        companyFilterOptions,
        onContractorSelected,
    } = props;

    const { t } = useTranslation()
    const history = useHistory()

    const [contractorDataGrid, setContractorDataGrid] = useState(contractors);
    const [contractorSearch, setContractorSearch] = useState("");
    const [contractorPersonType, seContractorPersonType] = useState(9)

    const contractorRepseType = [
        {
            name: "Proveedor REPSE Persona Física",
            value: 9
        },
        {
            name: "Proveedor REPSE Persona Moral",
            value: 10
        }
    ]

    const showSwiper = useMediaQuery("(max-width:1000px)");

    useEffect(() => {
        setContractorDataGrid(contractors);
    }, [contractors])

    // COMPANY FILTERS
    const onYearFilterChange = (event) => {
        const selectedOption = event.target.value;
        setContractorSearch("");
        props.onYearFilterChange(selectedOption);
    };

    const onCompanyFilterChange = (event) => {
        const selectedOption = event.target.value;
        setContractorSearch("");
        props.onCompanyFilterChange(selectedOption);
    };

    // COMPANY GRID
    const HeaderSemaforoCompany = () => {
        return <HeaderSemaforo showSwiper={showSwiper} swiperState={companySwiperState} />
    }

    const CellSemaforoEmpresa = (props) => {
        return (
            <CellSemaforo
                {...props}
                getColorByStatus={getColorByCompanyStatus}
                yearShown={selectedYear}
                showSwiper={showSwiper}
                swiperState={companySwiperState}
                onSlideChange={onCompanySlideChange}
            />
        );
    }

    // CONTRACTORS FILTER
    const onSearchContractorChange = (event) => {
        setContractorSearch(event.target.value);
    }

    useEffect(() => {
        if (!contractors.length) return;
        let filtered = contractors.filter((item) => item.name.toLowerCase().includes(contractorSearch.trim().toLowerCase()));
        setContractorDataGrid(filtered);
    }, [contractorSearch])

    // CONTRACTORS GRID
    const onRowClickContractor = (contractor) => {
        onContractorSelected(contractor);
    }

    const HeaderSemaforoProveedor = () => {
        return <HeaderSemaforo showSwiper={showSwiper} swiperState={contractorSwiperState} />
    }

    const CellColumnOneProveedor = (props) => {
        return <CellColumnOne {...props} onRowClick={onRowClickContractor} showImage />
    }

    const CellSemaforoProveedor = (props) => {
        return (
            <CellSemaforo
                {...props}
                getColorByStatus={getColorByContractorStatus}
                statusFieldName={"status"}
                yearShown={selectedYear}
                showSwiper={showSwiper}
                swiperState={contractorSwiperState}
                onSlideChange={onContractorSlideChange}
                onRowClick={onRowClickContractor}
            />
        );
    }

    // SWIPERS
    const [companySwiperState, setCompanySwiperState] = useState({
        currSlide: 0,
        prevSlide: 0,
        touchedId: null,
        active: false,
    })
    const [contractorSwiperState, setContractorSwiperState] = useState({
        currSlide: 0,
        prevSlide: 0,
        touchedId: null,
        active: false,
    })

    useEffect(() => {
        const today = new Date();
        let initialIndex = selectedYear == today.getFullYear() ? today.getMonth() : 0;
        setContractorSwiperState({
            currSlide: initialIndex,
            prevSlide: initialIndex,
            touchedId: null,
            active: false,
        })
        setCompanySwiperState({
            currSlide: initialIndex,
            prevSlide: initialIndex,
            touchedId: null,
            active: false,
        })
    }, [selectedYear])

    const onCompanySlideChange = (swiper, id) => {
        let index = swiper.activeIndex;
        if (companySwiperState.currSlide == index) return;

        setContractorSwiperState(prev => ({ ...prev, active: false }));
        setCompanySwiperState(prev => ({
            currSlide: index,
            prevSlide: prev.currSlide,
            touchedId: id,
            active: true,
        }));
    }

    const onContractorSlideChange = (swiper, id) => {
        let index = swiper.activeIndex;
        if (contractorSwiperState.currSlide == index) return;

        setCompanySwiperState(prev => ({ ...prev, active: false }));
        setContractorSwiperState(prev => ({
            currSlide: index,
            prevSlide: prev.currSlide,
            touchedId: id,
            active: true,
        }));
    }

    // AGREGAR PROVEEDOR
    const [showDialog, setShowDialog] = useState(false);
    const [newContractor, setNewContractor] = useState({
        name: "",
        email: "",
        limitDate: "",
        notes: "",
    });
    const [itselfRegister, setItselfRegister] = useState(false);
    const [errorInEmail, setErrorInEmail] = useState(false);
    const [errorInDate, setErrorInDate] = useState(false);

    const today = new Date();
    let limitMaxDate = new Date();
    limitMaxDate.setDate(limitMaxDate.getDate() + 61);

    const openDialog = () => {
        setNewContractor({
            name: "",
            email: "",
            limitDate: "",
            notes: "",
        });
        setItselfRegister(false);
        setErrorInEmail(false);
        setErrorInDate(false);
        setShowDialog(true);
    }

    const handleItselfRegister = (e) => {
        setItselfRegister(e.target.checked);
        if (e.target.checked) {
            changeNewContractor(props.email, "email");
        } else {
            changeNewContractor("", "email");
        }
    };

    const changeNewContractor = (value, field) => {
        if (field == "limitDate" && !validateDate(value)) return;
        if (field == "email") setErrorInEmail(false);

        setNewContractor(prev => ({
            ...prev,
            [field]: value
        }));
    }

    const validateDate = (value) => {
        let todayDate = new Date();
        let eventDate = new Date(value);

        eventDate.setHours(0, 0, 0, 0);
        todayDate.setHours(0, 0, 0, 0);

        if (
            eventDate < todayDate ||
            eventDate > limitMaxDate ||
            eventDate === null
        ) {
            setErrorInDate(true);
            return false;
        } else if (eventDate >= todayDate || eventDate <= limitMaxDate) {
            setErrorInDate(false);
            return true;
        }
    };

    const createContractor = () => {
        let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (newContractor.email.match(emailRegex)) {
            const { name, email, limitDate, notes } = newContractor;
            props.createContractor(email, name, limitDate, notes, contractorPersonType);
            setShowDialog(false);
        } else {
            setErrorInEmail(true);
        }
    }

    return (
        <>
            <Grid item xs={12}>
                <div className='RepseStatusView-company-filters'>
                    <ButtonAddHLPure
                        nameBtn={"Agregar proveedor"}
                        onClickBtn={openDialog}
                        iconAdd
                    />

                    <FilterHLPure
                        options={yearFilterOptions}
                        optionsValue={selectedYear.toString()}
                        nameOption="year"
                        valueItem="yearValue"
                        onFilterChange={onYearFilterChange} />

                    {
                        selectedCompany &&
                        <FilterHLPure
                            options={companyFilterOptions}
                            optionsValue={selectedCompany.id}
                            nameOption="name"
                            valueItem="id"
                            onFilterChange={onCompanyFilterChange} />
                    }

                </div>
            </Grid>


            <Grid item xs={12} className='RepseGrid'>
                <GridSelectionHLPure
                    skip={0}
                    take={1}
                    pageable={false}
                    dataGrid={selectedCompany ? [selectedCompany] : []}

                    titleRow1={"Empresa"}
                    cellColumnOne={CellColumnOne}
                    headerColumnOne={HeaderColumnOne}

                    columnTwo
                    titleRow2={""}
                    cellColumnTwo={CellSemaforoEmpresa}
                    headerColumnTwo={HeaderSemaforoCompany}
                />
            </Grid>

            {selectedCompany &&
                <>
                    <Grid item xs={12}>
                        <div className='RepseStatusView-contractors-title'>
                            <h3>Proveedores</h3>
                        </div>
                        <div className='RepseStatusView-contractors-filters'>
                            <SearchBarHLPure
                                searchValue={contractorSearch}
                                placeholder="Buscar proveedor"
                                onSearchChange={onSearchContractorChange} />
                        </div>
                    </Grid><Grid item xs={12} className='RepseGrid RepseStatusView-contractors-grid'>
                        <GridSelectionHLPure
                            skip={0}
                            take={6}
                            dataGrid={contractorDataGrid}
                            onRowClick={onRowClickContractor}

                            titleRow1={"Proveedor"}
                            cellColumnOne={CellColumnOneProveedor}
                            headerColumnOne={HeaderColumnOne}

                            columnTwo
                            titleRow2={""}
                            cellColumnTwo={CellSemaforoProveedor}
                            headerColumnTwo={HeaderSemaforoProveedor} />
                    </Grid>
                </>
            }

            <Grid
                container
                style={{ justifyContent: "flex-end" }}
            >
                <ButtonHLPure
                    nameBtn={t("button.return")}
                    onClickBtn={() => history.push("/help-desk")}
                />
            </Grid>

            {showDialog &&
                <DialogContractor
                    //Nombre
                    labelNameInput={"Nombre o razón social"}
                    stateNameContractor={newContractor.name}
                    onChangeNameContractor={(e) => changeNewContractor(e.target.value, "name")}
                    //Correo
                    labelEmailInput={"Correo del proveedor REPSE"}
                    stateEmailContractor={newContractor.email}
                    onChangeEmailContractor={(e) => changeNewContractor(e.target.value, "email")}
                    onEmailErrorState={errorInEmail}
                    myselfRegisterState={itselfRegister}
                    onChangeMyselfRegister={handleItselfRegister}
                    //Fecha
                    labelDataPicker={"Fecha limite de alta"}
                    stateDate={newContractor.limitDate}
                    limitDate={today}
                    limitMaxDate={limitMaxDate}
                    onChangeDateContractor={(e) => changeNewContractor(e.target.value, "limitDate")}
                    onErrorDateState={errorInDate}
                    //Notas
                    stateNotesContractor={newContractor.notes}
                    onChangeNotesContractor={(e) => changeNewContractor(e.target.value, "notes")}
                    //Dropdown
                    personTypeLabel={"Tipo de persona"}
                    onTypePersonChange={(e) => seContractorPersonType(Number(e.target.value))}
                    contractorsTypeOptions={contractorRepseType}
                    valueOptionDropdown={"value"}
                    nameOptionDropdown={"name"}
                    //Botones y Dialog
                    cancelName={"Cancelar"}
                    submitName={"Guardar"}
                    titleDialog={"Crear un nuevo proveedor REPSE"}
                    cancel={() => setShowDialog(false)}
                    handleSubmit={createContractor}
                />
            }

        </>
    )
}

export default RepseStatusCompanyView